import styled from 'styled-components';

export const DeadlineCell = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: visible !important;

  .deadLine {
    width: 95px;
  }

  svg {
    cursor: pointer;

    :hover {
      color: var(--color-accent);
    }
  }
`;
